import React, { useCallback } from "react";
import T from "prop-types";

import Image from "2g-image";

import { Prilohy } from "b2b/components/prilohy/Prilohy";
import { FILES } from "b2b/api";
import { useDownloadFile } from "b2b/api/hooks";
import { useServerMessage } from "b2b/i18n";
import { useImagePreview } from "b2b/components/prilohy";

function Detail({ provozniInformace }) {
  const serverMessage = useServerMessage();
  const image = useImagePreview(provozniInformace?.obrazek);

  const downloadFile = useDownloadFile();
  const onDownload = useCallback(file => {
    file.key && downloadFile(FILES.provozniInformace(file.key));
  }, []);

  return (
    <div className="b2b-ProvozniInformaceDetail">
      <div>
        {image ? <Image src={image} /> : undefined}
        {serverMessage(provozniInformace, "obsah")}
      </div>
      <div className="clear"></div>
      <Prilohy onDownload={onDownload} files={provozniInformace?.prilohy} />
    </div>
  );
}

Detail.propTypes = {
  provozniInformace: T.shape({
    obrazek: T.object,
    prilohy: T.array,
    obsahCs: T.string,
    obsahEn: T.string
  })
};

export default React.memo(Detail);
